import React, { useState } from 'react';
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Paper
} from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export default function Login({ onLogin }) {
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // در پروژه واقعی باید اعتبارسنجی انجام شود
    onLogin();              // 🔹 وضعیت ورود را فعال می‌کند
    navigate('/dashboard'); // 🔹 هدایت به داشبورد
  };

  return (
    <Container maxWidth="xs">
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Paper elevation={4} sx={{ mt: 8, p: 4, borderRadius: 3 }}>
          <Typography variant="h5" align="center" gutterBottom>
            {isLogin ? 'Login to Your Account' : 'Create an Account'}
          </Typography>

          <Box component="form" onSubmit={handleSubmit}>
            {!isLogin && (
              <TextField
                margin="normal"
                required
                fullWidth
                label="Full Name"
                name="name"
              />
            )}
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email Address"
              name="email"
              type="email"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Password"
              name="password"
              type="password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              {isLogin ? 'Login' : 'Sign Up'}
            </Button>
          </Box>

          <Typography align="center" variant="body2">
            {isLogin ? "Don't have an account?" : 'Already have an account?'}
            <Button variant="text" size="small" onClick={() => setIsLogin(!isLogin)}>
              {isLogin ? 'Sign Up' : 'Login'}
            </Button>
          </Typography>
        </Paper>
      </motion.div>
    </Container>
  );
}
